<template>
  <vs-popup :active.sync="localActive" title="Facturación retroactiva" fullscreen>
    <div class="row">
      <vs-tabs v-model="activeTab">
        <vs-tab label="Trx de retención">
          <retention-trx-generator
            @onSuccess="nextTabHandler(1)"
            :interest-trx-ids="data.applicant_trx_summary.interest_trxs_id"/>

          <vs-button color="dark" @click="nextTabHandler(1)">
            Siguiente
          </vs-button>
        </vs-tab>
        <vs-tab label="Actualización de referencias">
          <investor-retention-trx-updater
            :interest-trx-ids="data.applicant_trx_summary.interest_trxs_id"
            @onSuccess="nextTabHandler(2)"/>

          <vs-button color="dark" @click="nextTabHandler(3)">
            Siguiente
          </vs-button>
        </vs-tab>
        <vs-tab label="Enviar a facturar">
          <vs-input label="CID" disabled v-model="applicantId"></vs-input>
          <vs-input label="Fecha de ejercicio" v-model="exerciseDate" disabled></vs-input>

          <vs-button @click="sendInvoiceJobHandler" color="dark" class="mt-10">
            Enviar a facturar
          </vs-button>
        </vs-tab>
      </vs-tabs>
    </div>
  </vs-popup>
</template>
<script>
import RetentionTrxGenerator from "@views/admin/retention-dashboard/v2/RetroactiveBilling/RetentionTrxGenerator.vue";
import InvestorRetentionTrxUpdater
  from "@views/admin/retention-dashboard/v2/RetroactiveBilling/InvestorRetentionTrxUpdater.vue";

export default {
  name: 'RetroactiveBilling',
  components: {InvestorRetentionTrxUpdater, RetentionTrxGenerator},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    applicantId: {
      type: Number,
      default: null
    },
    exerciseDate: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    localActive: {
      get: function () {
        return this.active
      },
      set: function (value) {
        this.$emit('update:active', value)
      }
    }
  },
  data: () => ({
    activeTab: 0,
  }),
  methods: {
    nextTabHandler(tab) {
      this.activeTab = tab
    },
    async sendInvoiceJobHandler() {
      this.$vs.loading();

      try {
        await axios.post(`/api/billing/order-invoices/resend/all`, {
          exercise_date: this.exerciseDate,
          applicant_id: this.applicantId
        })

        this.successNotif('Éxito', 'Se ha enviado a facturar correctamente')
      } catch (e) {
        this.errorNotif('Error', e.response.data.message)
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>
<style scoped>

</style>